export enum TeamEvent {
  ON_TEAM_ADDED = 'TeamEvent:ON_TEAM_ADDED',
  ON_TEAM_UPDATED = 'TeamEvent:ON_TEAM_UPDATED',
  ON_TEAM_MEMBER_INVITED = 'TeamEvent:ON_TEAM_MEMBER_INVITED',
  ON_TEAM_CHANGED = 'TeamEvent:ON_TEAM_CHANGED',
  ON_TEAMS_LOADED = 'TeamEvent:ON_TEAMS_LOADED',
  ON_TEAM_DELETED = 'TeamEvent:ON_TEAM_DELETED',
  ON_TEAM_MEMBER_DELETED = 'TeamEvent:ON_TEAM_MEMBER_DELETED'
}
